import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
export function useProspects(filters = {}) {
    return useQuery({
        queryKey: ['prospects', filters],
        queryFn: () => {
            const params = new URLSearchParams();
            if (filters.status)
                params.set('status', filters.status);
            if (filters.managed !== undefined)
                params.set('managed', String(filters.managed));
            const qs = params.toString();
            return apiClient(`/prospects${qs ? `?${qs}` : ''}`);
        },
        staleTime: 1000 * 60 * 2,
    });
}
export function useUpdateProspectStatus(id) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (status) => apiClient(`/prospects/${id}/status`, {
            method: 'PATCH',
            body: JSON.stringify({ status }),
        }),
        onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['prospects'] }),
    });
}
// ── Anotaciones privadas del director (prospect_notes) ──────────────────────
export function useProspectNotes(prospectId, enabled = true) {
    return useQuery({
        queryKey: ['prospects', prospectId, 'notes'],
        queryFn: () => apiClient(`/prospects/${prospectId}/notes`),
        enabled: !!prospectId && enabled,
        staleTime: 1000 * 60,
    });
}
export function useAddProspectNote(prospectId) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (note) => apiClient(`/prospects/${prospectId}/notes`, {
            method: 'POST',
            body: JSON.stringify({ note }),
        }),
        onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['prospects', prospectId, 'notes'] }),
    });
}
export function useDeleteProspectNote(prospectId) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (noteId) => apiClient(`/prospects/${prospectId}/notes/${noteId}`, { method: 'DELETE' }),
        onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['prospects', prospectId, 'notes'] }),
    });
}
export function useConvertProspect(id) {
    const queryClient = useQueryClient();
    return useMutation({
        // Real endpoint: POST /students/from-prospect/:prospectId (body = createStudentSchema).
        // Returns the created student's temp_password so the director can relay credentials.
        mutationFn: (dto) => apiClient(`/students/from-prospect/${id}`, {
            method: 'POST',
            body: JSON.stringify(dto),
        }),
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: ['prospects'] });
            void queryClient.invalidateQueries({ queryKey: ['students'] });
        },
    });
}
//# sourceMappingURL=useProspects.js.map